import React from 'react'
import GlitchLogo from './GlitchLogo'

const Loader = ({ message = 'Загрузка...' }) => {
  return (
    <div className="min-h-screen text-white flex items-center justify-center">
      <div className="text-center">
        {/* Glitch-логотип вместо иконки кейса (вариант выбран на Playground) */}
        <GlitchLogo className="w-[220px] mx-auto mb-4" />
        <h2 className="text-xl font-semibold text-white mb-2 hidden" >
          {message}
        </h2>
        <div className="flex items-center justify-center gap-1 hidden">
          <div className="w-2 h-2 bg-accent-primary rounded-full animate-bounce"></div>
          <div className="w-2 h-2 bg-accent-primary rounded-full animate-bounce delay-100"></div>
          <div className="w-2 h-2 bg-accent-primary rounded-full animate-bounce delay-200"></div>
        </div>
      </div>
    </div>
  )
}

export default Loader
